import {CustomFieldTO} from 'generated/JavaTO'
import {CF} from 'module/CustomField/util/CustomField'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'

export function getMemoSelectedSize(cfDef: CustomFieldTO) {
	const a = CF.getCFAttr(cfDef, CFAttrKey.memoSelected)?.value
	if (!a?.trim()) return 5
	return parseInt(a) || 0
}

export function isMemoAutoAddActive(cfDef: CustomFieldTO){
	return CF.getCFAttr(cfDef, CFAttrKey.memoAutoAdd)?.value !== 'N'
}